module.exports = __webpack_public_path__ + "img/gift_total.3f2cbfc3.png";